import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthGuard } from './laas/auth-guard.service';
import { AdminAuthGuard } from './admin/admin-auth-guard.service';
import { AdminAuthGuardUtilities } from './admin/admin-auth-guard-utilities.service';
import { DigireportComponent } from './digireport/digireport.component';
import { LaasCbsAuthGuard } from './laas/laas-auth-guard.service';
import { ApplicantService } from './laas/applicant.service';
import { LaasComponent } from './laas/laas.component';

import { LandingModule } from './landing/landing.module';
import { LaasModule } from './laas/laas.module';
import { AdminModule } from './admin/admin.module';
import { FreshAppModule } from './fresh-app/fresh-app.module';

const routes: Routes = [
  { path: '', redirectTo: '/landing', pathMatch: 'full' },
  { path: 'laas', loadChildren: () => LaasModule, canActivate: [AuthGuard] },
  { path: 'admin', loadChildren: () => AdminModule, canActivate: [AdminAuthGuard, AdminAuthGuardUtilities] },
  { path: 'digi-report/:id', component: DigireportComponent },
  { path: 'fresh-app', loadChildren: () => FreshAppModule, canActivate: [AdminAuthGuard, AdminAuthGuardUtilities] },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
    LandingModule, // Eagerly loaded module
  ],
  exports: [RouterModule],
  providers: [AuthGuard, AdminAuthGuard, AdminAuthGuardUtilities, LaasCbsAuthGuard, ApplicantService, LaasComponent],
})
export class AppRoutingModule { }
